import React from 'react';
import { useWeb3 } from '../../contexts/Web3Context';
import { useUI } from '../../contexts/UIContext';
import { AlertTriangle } from 'lucide-react';

const ConnectionStatusBar = () => {
  const { isConnected } = useWeb3();
  const { networkError } = useUI();

  return (
    <div className="connection-status">
      {/* Logo */}
      <div className="grich-name">
        <span className="primary">Grich</span><span className="secondary">Inv</span>
      </div>
      
      {/* Connection status - centered */}
      <div className="status-display">
        <div className={`status-indicator ${isConnected && !networkError ? 'connected' : 'disconnected'}`}></div>
        <span>
          {networkError && (
            <AlertTriangle color="#ff2a6d" size={16} style={{ marginRight: '5px', verticalAlign: 'text-bottom' }} />
          )}
          {isConnected 
            ? networkError 
              ? 'Wrong Network' 
              : 'Connected'
            : 'Disconnected'
          }
        </span>
      </div>
      
      {/* Chain info */}
     
    </div>
  );
};

export default ConnectionStatusBar;